import { render, staticRenderFns } from "./conversion.vue?vue&type=template&id=82a6fdcc&scoped=true&"
import script from "./conversion.vue?vue&type=script&lang=js&"
export * from "./conversion.vue?vue&type=script&lang=js&"
import style0 from "./conversion.vue?vue&type=style&index=0&id=82a6fdcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a6fdcc",
  null
  
)

export default component.exports